module.exports = __webpack_public_path__ + "img/20190708165735360.3676ce2c.png";